module.exports = function getResource(label, vars = []) {
    const resources = {
        filterBy: 'Filtrer par',
        filter: 'Filtrer',
        resetAllFilters: 'Réinitialiser tous les filtres',
        clearAll: 'Tout réinitialiser',
        reset: 'Réinitialiser',
        done: 'Terminé',
        showResults: 'Afficher les résultats'
    };

    return resources[label];
};
